import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { CaseFormRepository } from '../../../infrastructure/repositories/case-form.repository';
import { CaseFormState } from '../../states/case-form.state';
import { RemoveFieldCommand } from './remove-field.command';

/**
 * Remove Field Use Case
 * Removes a field from a form version
 */
@Injectable({ providedIn: 'root' })
export class RemoveFieldUseCase {
  private readonly _repository = inject(CaseFormRepository);
  private readonly _state = inject(CaseFormState);

  public execute(command: RemoveFieldCommand): Observable<void> {
    this._state.setLoadingCaseForm(true);
    this._state.clearErrorCaseForms();

    return this._repository.removeField(command.versionId, command.fieldId).pipe(
      catchError((error) => {
        const errorMessage =
          error?.error?.message ||
          error?.message ||
          `Failed to remove field ${command.fieldId}`;
        this._state.setErrorCaseForms(errorMessage);
        return throwError(() => error);
      }),
      finalize(() => this._state.setLoadingCaseForm(false))
    );
  }
}
